import styled from 'styled-components';

import { scale060, xdlColorTextSecondary } from '@xing-com/tokens';

export const StatusFlag = styled.span<{ state: string }>`
  font-weight: ${({ state }) => (state === 'PINNED' ? 400 : 700)};
  font-size: ${scale060};
  color: ${xdlColorTextSecondary};
`;
